import { MDSIconKind } from "@/mds";
import type { AgentFilterSelectItem } from "@/pages/agent/components/agent-filter-select";
import { ProjectSortKey } from "@/pages/agent/projects/use-agent-projects-search-params";

export const buildProjectSortFilterItems = (): AgentFilterSelectItem[] => [
  {
    id: ProjectSortKey.RecentlyActive,
    label: "Recently active",
    iconKind: MDSIconKind.SortAlt,
  },
  {
    id: ProjectSortKey.Alphabetical,
    label: "Alphabetical",
    iconKind: MDSIconKind.SortAlt,
  },
];
